// extracted by mini-css-extract-plugin
module.exports = {"zoneModule":"styles_zoneModule__Pqhmr"};